import React, { useMemo, useEffect, useState } from "react";
import objectPath from "object-path";
import { Outlet } from "react-router-dom";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { AdminAside } from "./aside/AdminAside";
import { Footer } from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { ScrollTop } from "./extras/ScrollTop";

export function AdminLayout({ children }) {
   const uiService = useHtmlClassService();
   const layoutProps = useMemo(() => {
      return {
         selfLayout: objectPath.get(uiService.config, "self.layout"),
         subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
         contentCssClasses: uiService.getClasses("content", true),
         contentContainerClasses: uiService.getClasses("content_container", true),
         contentExtended: objectPath.get(uiService.config, "content.extended")
      };
   }, [uiService]);

   const [isMinimized, setIsMinimized] = useState(false);

   useEffect(() => {
      document.body.classList.remove("aside-minimize");
   }, []);

   const checkIsMenuMinimized = (data) => {
      setIsMinimized(data);
   };

   const validPaths = [
      "/admin-payment-plans",
      "/tasks",
      "/relationships",
      "/quick-actions"
      // "/task-management"
   ];

   const isMatchingPath = validPaths.some((path) => window.location.pathname.startsWith(path));
   return layoutProps.selfLayout !== "blank" ? (
      <>
         {/*begin::Main*/}
         <HeaderMobile />

         <div className="d-flex flex-column flex-root">
            {/*begin::Page*/}
            <div className="d-flex flex-row flex-column-fluid page">
               <AdminAside onMenuMinimize={checkIsMenuMinimized} />

               {/*begin::Wrapper*/}
               <div
                  className={`d-flex flex-column flex-row-fluid wrapper ${
                     isMinimized ? "minimized" : ""
                  }`}
                  // className="w-100"
                  id="kt_wrapper"
               >
                  {/*begin::Content*/}
                  <div
                     id="kt_content"
                     className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                  >
                     {layoutProps.subheaderDisplay && <SubHeader />}

                     {/*begin::Entry*/}
                     {layoutProps.contentExtended && <>{children}</>}

                     {!layoutProps.contentExtended && (
                        <div
                           className="d-flex flex-column-fluid justify-content-center"
                           style={{
                              backgroundColor: isMatchingPath ? "#252938" : "#eef2ff"
                           }}
                        >
                           {/*begin::Container*/}
                           <div
                              className={
                                 window.location.pathname.startsWith("/survey/data/") ||
                                 isMatchingPath
                                    ? "w-100"
                                    : layoutProps.contentContainerClasses
                              }
                              style={
                                 window.location.pathname.startsWith("/survey/test/") ||
                                 window.location.pathname.startsWith("/survey/submission/") ||
                                 window.location.pathname.startsWith("/deleted-items")
                                    ? { padding: "0" }
                                    : null
                              }
                           >
                              <Outlet />
                           </div>
                           {/*end::Container*/}
                        </div>
                     )}

                     {/*end::Entry*/}
                  </div>
                  {/*end::Content*/}
                  <Footer />
               </div>
               {/*end::Wrapper*/}
            </div>
            {/*end::Page*/}
         </div>

         <ScrollTop />

         {/*end::Main*/}
         <LayoutInit />
      </>
   ) : (
      // BLANK LAYOUT
      <div className="d-flex flex-column flex-root">{children}</div>
   );
}
